import { useState } from 'react'
import ClassNames from 'classnames'
import Button from '@material-ui/core/Button'
import classes from './styles/errorFallback.module.scss'
import l10n from '../i18n/I18N'
import { errorFallbackComponentsName } from './errorFallbackConstants'

export const ErrorFallback = ({ error, resetError, componentStack, componentName }) => {
  const [open, setOpen] = useState(false)

  let message = ''
  if (error) {
    if (error.message) {
      message = error.message
    } else {
      message = JSON.stringify(error)
    }
  }

  const categoryFeaturedListSubheader = ClassNames(classes.errorStack, {
    [classes.errorStack_close]: !open
  })

  const componentClassName = ClassNames(classes.errorWrapper, {
    [classes.errorWrapper_topOffset]: componentName === errorFallbackComponentsName.sideNavigation
  })

  return (
    <div className={componentClassName}>
      <div className={classes.errorContainer}>
        <p className={classes.errorMessage}>
          {l10n.t['errorFallback.errorMessageIn']} {componentName}:{' '}
          <span className={classes.errorMessageText}>{message}</span>
        </p>
        <Button variant="contained" color="primary" onClick={resetError}>
          {l10n.t['errorFallback.resetError']}
        </Button>
      </div>
      {componentStack && (
        <div className={classes.componentStackContainer}>
          <Button variant="contained" color="default" onClick={() => setOpen(!open)}>
            {open ? l10n.t['errorFallback.hideStackTrace'] : l10n.t['errorFallback.showStackTrace']}
          </Button>
          <div className={categoryFeaturedListSubheader}>
            {componentStack.split('\n').map((line, index) => (
              <div key={index} className={classes.errorStackLine}>
                {line}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
